import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from '../ButtonBit';
import {
  confirmationWrapper,
  warningText,
  buttonsRow,
} from './StoreSelectConfirmation.styles';

const StoreSelectConfirmation = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <div css={confirmationWrapper}>
      <span css={warningText}>{t('productOrder:confirmStoreChange')}</span>
      <div css={buttonsRow}>
        <Button variant="outlined" color="primary" onClick={onCancel}>
          {t('formValidation:cancel')}
        </Button>
        <Button color="primary" onClick={onConfirm}>
          {t('formValidation:confirm')}
        </Button>
      </div>
    </div>
  );
};

StoreSelectConfirmation.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default StoreSelectConfirmation;
